type EditingLiveLeaveHandler = () => Promise<void> | void;

let leaveHandler: EditingLiveLeaveHandler | null = null;
let remountHandler: (() => void) | null = null;

/**
 * 工作区把「结束当前直播」注册给侧栏。侧栏本身看不到 RTC / 摄像头，
 * 确认离开时必须先走这里，不能只 router.push 指望卸载清理。
 *
 * Next.js 16 cacheComponents 可能把 editing-pro layout 藏起来而不是卸载，
 * 所以离开时还要 flush 掉会话状态，并 remount 工作区实例。
 */
export const registerEditingLiveLeaveHandler = (handler: EditingLiveLeaveHandler | null): void => {
  leaveHandler = handler;
};

export const leaveActiveEditingLive = async (): Promise<void> => {
  const handler = leaveHandler;
  if (!handler) return;
  await handler();
};

export const registerEditingWorkspaceRemount = (handler: (() => void) | null): void => {
  remountHandler = handler;
};

export const remountEditingWorkspace = (): void => {
  remountHandler?.();
};
